import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { PoolsCollection } from './pools.types';
import { Pool } from '../enterprise/enterprise.model';

export function poolsBackend(): Backend<PoolsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/pools',
      params: {
        pools: ids,
        names: getQueryParamValue(query, 'name'),
        seo_url: getQueryParamValue(query, 'seoUrl'),
        is_talent_network: getQueryParamValue(query, 'isTalentNetwork')[0],
        is_insource_enabled: getQueryParamValue(query, 'isInsourceEnabled')[0],
        is_currency_enabled: getQueryParamValue(query, 'isCurrencyEnabled')[0],
        ignore_test: query?.searchQueryParams.ignoreTest,
        offset: query?.searchQueryParams.offset,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: (authUid, id, originalDocument) => {
      // Helper function to allow user to remove pool i.e. leave an expert community
      // Currently, we only allow user to leave Facebook on their own.

      if (id !== Pool.FACEBOOK) {
        throw new Error('Removing non-facebook pool is not allowed.');
      }

      return {
        endpoint: 'user/leaveExpertCommunity.php',
        method: 'POST',
        isGaf: true,
        payload: { id },
      };
    },
  };
}
